import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Router } from "@angular/router";
import { trimTextByWord } from "../../events-screen/utils/trimTextByWord";
import { GeneralRowEvent } from "../../../_models/general-row-event";
import { BaseDiscountModel } from "../discount-models/BaseDiscountModel";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import { I18nService } from "../../../_services/i18n.service";
import { RowEventEmit } from "../../events-screen/event-page-models/row-event-emit";
import { LanguageService } from "../../../_services/language.service";

@Component({
  selector: "discount-management-row",
  templateUrl: "./discount-management-row.component.html",
  styleUrls: ["./discount-management-row.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          maxHeight: "200px",
          opacity: 1,
          overflow: "visible",
        })
      ),
      state(
        "closed",
        style({
          maxHeight: "1px",
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class DiscountManagementRowComponent implements OnInit, OnDestroy {
  @Input("isSelected") public isSelected: boolean;
  @Output("rowEvent") public rowEvent: EventEmitter<
    GeneralRowEvent<BaseDiscountModel>
  > = new EventEmitter<GeneralRowEvent<BaseDiscountModel>>();

  public translations$: Observable<ITranslations>;
  public discountRowMenuOptions: Array<{
    action: string;
    text: string;
    customIcon?: string;
  }> = [
    {
      action: "edit",
      text: "עריכת סבסוד",
      customIcon: "editUserProfile",
    },
    {
      action: "delete",
      text: "מחיקת סבסוד",
      customIcon: "trashBin",
    },
  ];
  protected readonly transition = transition;

  constructor(
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private translationService: TranslationService,
    private languageService: LanguageService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public _discount: BaseDiscountModel;

  @Input() public set discount(value: BaseDiscountModel | null) {
    if (!value) {
      return;
    }
    this._discount = value;
  }

  public isGrownUpLayer(layer: string): boolean {
    return this.languageService.isGrownUpLayer(layer);
  }

  public formatDateToString(date: Date) {
    return I18nService.formatDateToString(date);
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  public formatDate(date: Date | any) {
    if (!date) {
      return "ללא";
    }
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }

  public rowClicked($event): void {
    const action = !this.isSelected ? "select" : "unselect";
    this.rowEvent.emit({
      action,
      eventId: this._discount.discountId.toString(),
      eventObject: this._discount,
    });
  }

  public changeStatus($event: any) {}

  public trimText(text: string, maxlength = 14) {
    return trimTextByWord(text, maxlength);
  }

  public expandRow() {
    this.rowClicked(event);
  }

  public menuEventHandler($event: RowEventEmit) {
    this.rowEvent.emit({
      action: $event.action as "edit" | "delete",
      eventId: this._discount.discountId.toString(),
      eventObject: this._discount,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/discount-management-row/discount-management-row.component.ts